@use "../../sass/global/global" as *;

ux-iws-nb-intermediate-title {
    @include font(light);
    display: block;
    position: relative;
    box-sizing: border-box;
    padding: 0;
    margin-bottom: 30px;
    max-width: 640px;

    @media (min-width: 768px) {
        margin-bottom: 60px;
    }

    @media (min-width: 1440px) {
        max-width: 900px;
    }

    @media (min-width: 1800px) {
        max-width: 1200px;
    }

    [slot="title"] {
        margin: 0;
        @include nb-heading(5, true);
    }

    [slot="subtitle"] {
        margin: 0;
        @include nb-heading(5, false);
    }
}
